export enum SelectedQuotesIneligibilityModalResult {
  RemoveIneligibleAppliance = 'removeIneligibleAppliance',
}
